export const COOKIES_ENABLED = 'cookiesEnabled'
export const SCREEN_LOADING = 'screenLoading'

export const TYPE_ROAD_TEST = 'typeRoadTest'
export const MASTER_NUMBER = 'masterNumber'
export const DRIVER_FIRST_NAME = 'driverFirstName'
export const DRIVER_LAST_NAME = 'driverLastName'
export const DATE_OF_BIRTH = 'dateOfBirth'
export const EMAIL_ADDRESS = 'emailAddress'
export const CONFIRM_EMAIL_ADDRESS = 'confirmEmailAddress'
export const PHONE_NUMBER = 'phoneNumber'
export const MASTER_NUMBER_DOB = 'masterNumberDOB'

export const DRIVING_SCHOOL_NAME = 'drivingSchoolName'
export const CONTACT_NAME = 'contactName'
export const DRIVING_SCHOOL_PHONE_NUMBER = 'drivingSchoolphoneNumber'

export const CLEAR_ALL = 'clearAll'
export const CLEAR_ALL_FIELDS = 'clearAllFields'
